var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 15.3934L11.8451 11.6551C12.721 10.6228 13.2523 9.29054 13.2523 7.83379C13.2523 4.57097 10.5973 1.91602 7.33446 1.91602C4.07165 1.91602 1.41669 4.57097 1.41669 7.83379C1.41669 11.0967 4.07165 13.7516 7.33446 13.7516C8.79122 13.7516 10.1235 13.2203 11.1558 12.3444L14.8941 16.0827L15.5834 15.3934ZM2.39156 7.83379C2.39156 5.10866 4.60934 2.89088 7.33446 2.89088C10.0596 2.89088 12.2774 5.10866 12.2774 7.83379C12.2774 10.559 10.0596 12.7767 7.33446 12.7767C4.60934 12.7767 2.39156 10.559 2.39156 7.83379Z",
    fill: "var(--color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconDark);
export default __webpack_public_path__ + "static/media/searchIconDark.2c870dc050bbf3111c52f6fc84cd18de.svg";
export { ForwardRef as ReactComponent };